import { deepMerge } from '../../utils';
import { HoneycombComponents, HoneycombComponentsOverrides } from '../types/HoneycombComponents';
import {
    ACCORDION_DEFAULT_THEME,
    ACTION_BUTTON_DEFAULT_THEME,
    ALERT_NOTICE_DEFAULT_THEME,
    BUTTON_DEFAULT_THEME,
    CARD_DEFAULT_THEME,
    CAROUSEL_DEFAULT_THEME,
    CHECKBOX_DEFAULT_THEME,
    CHIP_DEFAULT_THEME,
    DATE_PICKER_DEAL_BUTTON_DEFAULT_THEME,
    DIALOG_DEFAULT_THEME,
    DIGITAL_CLOCK_DEFAULT_THEME,
    FIELD_BASE_DEFAULT_THEME,
    FLAG_DEFAULT_THEME,
    GALLERY_DEFAULT_THEME,
    ICON_BUTTON_DEFAULT_THEME,
    MODULAR_PRICE_DEFAULT_THEME,
    NOTIFICATION_DEFAULT_THEME,
    OPTION_DEFAULT_THEME,
    POPOVER_DEFAULT_THEME,
    RADIO_DEFAULT_THEME,
    SCORE_DEFAULT_THEME,
    SEAT_ICON_DEFAULT_THEME,
    STAMP_DEFAULT_THEME,
    STEPPER_DEFAULT_THEME,
    SWITCH_DEFAULT_THEME,
    SWITCHOPTION_DEFAULT_THEME,
    TABS_DEFAULT_THEME,
    TIMELINE_DEFAULT_THEME,
} from './components';

export function createComponents(options?: HoneycombComponentsOverrides): HoneycombComponents {
    return deepMerge(
        {
            defaultProps: {},
            themes: {
                Accordion: ACCORDION_DEFAULT_THEME,
                ActionButton: ACTION_BUTTON_DEFAULT_THEME,
                AlertNotice: ALERT_NOTICE_DEFAULT_THEME,
                Button: BUTTON_DEFAULT_THEME,
                Card: CARD_DEFAULT_THEME,
                Carousel: CAROUSEL_DEFAULT_THEME,
                Checkbox: CHECKBOX_DEFAULT_THEME,
                Chip: CHIP_DEFAULT_THEME,
                DatePickerDealButton: DATE_PICKER_DEAL_BUTTON_DEFAULT_THEME,
                Dialog: DIALOG_DEFAULT_THEME,
                DigitalClock: DIGITAL_CLOCK_DEFAULT_THEME,
                FieldBase: FIELD_BASE_DEFAULT_THEME,
                Flag: FLAG_DEFAULT_THEME,
                Gallery: GALLERY_DEFAULT_THEME,
                IconButton: ICON_BUTTON_DEFAULT_THEME,
                ModularPrice: MODULAR_PRICE_DEFAULT_THEME,
                Notification: NOTIFICATION_DEFAULT_THEME,
                Option: OPTION_DEFAULT_THEME,
                Popover: POPOVER_DEFAULT_THEME,
                Radio: RADIO_DEFAULT_THEME,
                Score: SCORE_DEFAULT_THEME,
                SeatIcon: SEAT_ICON_DEFAULT_THEME,
                Stamp: STAMP_DEFAULT_THEME,
                Stepper: STEPPER_DEFAULT_THEME,
                Switch: SWITCH_DEFAULT_THEME,
                SwitchOption: SWITCHOPTION_DEFAULT_THEME,
                Tabs: TABS_DEFAULT_THEME,
                Timeline: TIMELINE_DEFAULT_THEME,
            },
        },
        options
    );
}
